<template>
	<div style="background-color: white">
		<!-- Navigation -->
		<HeaderGlobal :secondaryHeader="true" :qtSomos="qtSomos" :key="qtSomos" />
		<!-- Page Content -->
		<div class="container-fluid question content-desktop">
			<div
				:class="template.style.surveyBackground ? 'text-white' : 'text-dark'"
				class="container container-content border-left-light pt-2 pb-5"
			>
				<div class="row">
					<div class="col-lg-6 px-lg-5">
						<div>
							<h4
								:class="survey.id == 552 ? 'text-survey-color' : ''"
								class="bold t-1"
							>
								{{ config.title }}
								<p class="light">
									{{ config.subtitle }}
								</p>
							</h4>
							<h3 class="text-survey-color extra-bold text-uppercase">
								{{ config.chapterName }}
							</h3>
							<p :class="survey.id == 552 ? 'text-survey-color' : ''">
								{{ config.intro }}
							</p>
						</div>
					</div>
					<div class="pt-5 px-lg-5 col-lg-6">
						<div class="row">
							<div class="col-12 question-navegation px-0">
								<!-- Progress bar -->
								<progress-bar
									style="margin-bottom: -3.5rem"
									:percent-done="percentDone"
								/>
								<!-- Registration steps -->
								<component
									:is="steps[activeStepIndex]"
									:profile="localProfile"
									:processingApi="processingApi"
									:activeStepIndex="activeStepIndex"
									class="mt-4 px-3"
									@next="goToNextStep"
									@prev="goToPrevStep"
									@start-survey="startSurvey"
									@processing="updateProcessing"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<FooterGlobal :secondaryFooter="true" :qtSomos="qtSomos" />
	</div>
</template>

<script>
// Components
import HeaderGlobal from "../HeaderGlobal.vue";
import FooterGlobal from "../FooterGlobal.vue";
import Name from "@/components/registration/Name";
import FullNameAndSocialName from "@/components/registration/FullNameAndSocialName.vue";
import Cpf from "@/components/registration/Cpf";
import Password from "@/components/registration/Password.vue";
import Phone from "@/components/registration/Phone";
import Email from "@/components/registration/Email";
import Cep from "@/components/registration/Cep";
import Country from "@/components/registration/Country";
import Address from "@/components/registration/Address";
import GenderAndBirthDate from "@/components/registration/GenderAndBirthDate";
import ProgressBar from "@/components/registration/components/ProgressBar";

// Services
import { Survey, Register } from "../../services/Survey.js";
const s = new Survey();
const register = new Register();

export default {
	name: "BeginRegister",
	components: {
		HeaderGlobal,
		FooterGlobal,
		ProgressBar,
		Name,
		FullNameAndSocialName,
		Cpf,
		Password,
		Phone,
		Email,
		GenderAndBirthDate,
		Cep,
		Country,
		Address,
	},
	data: () => ({
		qtSomos: 0,
		activeStepIndex: 0,
		processingApi: false,
		payloadToRegister: {},

		localProfile: {
			Name1: "",
			Name2: "",
			SocialName: "",
			Gender: "",
			Birthdate: "",
			Numbers: [
				{
					Identity: 0,
					NumberType: 1,
					Number: "",
					Verified: 0,
				},
				{
					Identity: 0,
					NumberType: 4,
					Number: "",
					Verified: 0,
				},
				{
					Identity: 0,
					NumberType: 3,
					Number: "",
					Verified: 0,
				},
			],
			Address: {
				Add1: "",
				Add2: "",
				Add3: "",
				Number: "",
				Zip: "",
				City: "",
				State: "",
				Country: "",
			},
			Password: "",
		},
		config: {
			title: "Ops!",
			subtitle: "",
			chapterName: "",
			intro: "",
			registrationSteps: [
				"Name",
				"Phone",
				"Email",
				"GenderAndBirthDate",
				"Cep",
				"Country",
				"Address",
			],
		},
	}),
	created() {
		this.config.subtitle = this.$t("not_identified");
		this.config.chapterName = this.$t("fast_game");
		this.config.intro = this.$t("need_info");
		if (!Object.keys(this.template).length) {
			this.$router.push("Home");
		}
		this.qtSomos = this.$store.state.qtUsers;

		this.activeStepIndex = 0;

		this.setCodeToProfile();

		this.getRegistrationConfigsFromTemplate();

		this.getParams();
	},
	computed: {
		registrationCode() {
			return this.$store.getters.getRegistrationCode;
		},
		template() {
			return this.$store.state.template;
		},
		style() {
			return this.$store.state.template.style;
		},
		survey() {
			return this.$store.state.template.survey;
		},
		steps() {
			if (!this.config) return [];
			return this.config.registrationSteps;
		},
		isFirstStep() {
			return this.activeStepIndex === 0;
		},
		percentDone() {
			return (this.activeStepIndex / this.steps.length) * 100;
		},
		templateSurvey() {
			return this.$store.state.template.survey;
		},
	},
	methods: {
		getParams() {
			this.params = Object.fromEntries(
				new URLSearchParams(window.location.search)
			);
			this.surveyType = this.params.st;
		},
		getRegistrationConfigsFromTemplate() {
			if (this.template.registration.title !== "")
				this.config.title = this.template.registration.title;
			if (this.template.registration.subtitle !== "")
				this.config.subtitle = this.template.registration.subtitle;
			if (this.template.registration.chapterName !== "")
				this.config.chapterName = this.template.registration.chapterName;
			if (this.template.registration.intro !== "")
				this.config.intro = this.template.registration.intro;
			if (this.template.registration.registrationSteps.length) {
				this.config.registrationSteps = this.template.registration.registrationSteps;
			}
			if (this.template.registration.title == undefined) this.config.title = "";
			if (this.template.registration.subtitle == undefined)
				this.config.subtitle = "";
			if (this.template.registration.chapterName == undefined)
				this.config.chapterName = "";
			if (this.template.registration.intro == undefined) this.config.intro = "";
			if (this.template.registration.registrationSteps.length) {
				this.config.registrationSteps = this.template.registration.registrationSteps;
			}
		},
		setCodeToProfile() {
			if (this.template.home.useEmail) {
				this.localProfile.Numbers[1].Number = this.registrationCode;
			} else {
				this.localProfile.Numbers[0].Number = this.registrationCode;
			}
		},
		setUpSurvey(resp) {
			this.$store.commit("SET_SurveyStruct", resp.surveyStruct);
			this.$store.commit("SET_Req", resp.currentReq);
			this.$store.commit("SET_Chapter", resp.currentChapter);
			this.$store.commit("SET_SurveyUserId", resp.userSurveyId);
			this.$store.commit("SET_UserId", this.cpf);
			this.$store.commit("SET_LastReq", resp.currentReq);
			if (resp.currentReq != 0) {
				this.$store.commit("SET_StarNextReq", true);
			}
		},
		addAnswers(answers) {
			if (answers) {
				for (var i = 0; i < answers.length; i++) {
					var payload = {
						questid: answers[i].id,
						value: answers[i].value,
					};
					this.$store.commit("SET_Answer", payload);
				}
			}
		},
		setPayloadToRegisterProfile() {
			this.payloadToRegister.SurveyId = Number(this.template.survey.id);
			this.payloadToRegister.Profile = JSON.parse(
				JSON.stringify(this.localProfile)
			);
			delete this.payloadToRegister.Profile.Address;
			this.payloadToRegister.Address = JSON.parse(
				JSON.stringify(this.localProfile.Address)
			);
		},
		submit: async function() {
			this.processingApi = true;
			try {
				this.setPayloadToRegisterProfile();
				const resp = await register.registerProfile(this.payloadToRegister);
				if (resp.data) {
					this.startSurvey(resp.data, resp.header.msg);
				}
			} catch (err) {
				this.processingApi = false;
				this.$vs.notify({
					color: "RGBA(255,0,0)",
					title: this.$t("problem_ocurred"),
					text: `Erro ao registrar perfil: ` + err,
					time: 5000,
				});
			}
		},
		async startSurvey(registerId, registerMsg) {
			this.params.confirmationCode = this.localProfile.Birthdate;
			try {
				const resp = await s.Start(
					this.registrationCode,
					"",
					this.template.survey.id,
					this.template.survey.prj,
					this.params,
					registerId,
					registerMsg
				);
				this.setUpSurvey(resp);
				this.addAnswers(resp.answers);

				this.processingApi = false;
				if (resp.surveyEnded) {
					this.$router.push("finalSurvey");
				} else {
					this.$router.push("survey");
				}
			} catch (err) {
				this.$vs.notify({
					color: "RGBA(255,0,0)",
					title: `Um erro ocorreu!`,
					text: err,
					time: 5000,
				});
			}
			this.processingApi = false;
		},
		goToNextStep() {
			if (this.activeStepIndex < this.steps.length - 1) {
				this.activeStepIndex++;
			} else {
				this.params.approv && this.templateSurvey.phase === "TEST"
					? this.startSurvey()
					: this.submit();
			}
		},
		goToPrevStep() {
			if (!this.isFirstStep) {
				this.activeStepIndex--;
			}
		},
		updateProcessing(arg) {
			this.processingApi = arg;
		},
	},
};
</script>

<style>
.error {
	color: red;
}
</style>
